import * as api from '../../api/api-encargado-compania';
import { 
    GET_CONFIG_FORM23,
    OBTENER_LLAVES,
    GET_DATOS_GESTION,
    GET_COMBO_GESTION,
    POST_PROCESAR,
    GET_MONTOS
   
} from '../types';

export const configuracionFormAction23 = (query) => ({
    type: GET_CONFIG_FORM23,
    payload: api.getConfiguracionForm23(query)
});

export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});
export const obtenerDatosGestionImplicado = (query) => ({
    type:GET_DATOS_GESTION,
    payload: api.getDatosGestionImplicado(query)
});
export const obtenerMontos = (query) => ({
    type:GET_MONTOS,
    payload: api.getMontosInformados(query)
});
export const obtenerComboGestion = (query) => ({
    type:GET_COMBO_GESTION,
    payload: api.getComboGestionAnalista(query)
});
export const enviarProceso = (proce) => ({
    type:POST_PROCESAR,
    payload: api.postProcesar(proce)
});